import api from './api';
class DashboardService {
    getDashbaord(year) {
        return api.get('/api/v1/dashboard', { params: { periodId: year } });
    }
    getPrivateDashbaord(params) {
        return api.get('/api/v1/dashboard/private',{ params: params });
    }
    downloadQuestion(option) {
        return api.get('/api/v1/dashboard/download',option);
    }
    viewQuestions(year) {
        return api.get('/api/v1/dashboard/questions/view',{ params: { periodId: year } });
    }
    downloadConsolidado(year) {
        return api.get('/api/v1/dashboard/private/download',{ params: { periodId: year } });
    }
    cleanCache() {
        return api.get('/api/v1/benchmark/get/all');
    }
    downloadPercent(year) {
        return api.get('/api/v1/dashboard/private/download/percent', { params: { periodId: year } });
    }
    putTerms() {
        return api.post('/api/v1/dashboard/terms');
    }
    putCompany(params) {
        return api.post('/api/v1/dashboard/company',params);
    }
}
export default new DashboardService();
